// source: proto/services/captcha_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var proto_messages_common_pb = require('../../proto/messages/common_pb.js');
goog.object.extend(proto, proto_messages_common_pb);
goog.exportSymbol('proto.proto.services.CreateCaptchaRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.services.CreateCaptchaRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.services.CreateCaptchaRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.services.CreateCaptchaRequest.displayName = 'proto.proto.services.CreateCaptchaRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.services.CreateCaptchaRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.services.CreateCaptchaRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.services.CreateCaptchaRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.services.CreateCaptchaRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    phone: (f = msg.getPhone()) && proto_messages_common_pb.Phone.toObject(includeInstance, f),
    deviceid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    islogin: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    channel: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.services.CreateCaptchaRequest}
 */
proto.proto.services.CreateCaptchaRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.services.CreateCaptchaRequest;
  return proto.proto.services.CreateCaptchaRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.services.CreateCaptchaRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.services.CreateCaptchaRequest}
 */
proto.proto.services.CreateCaptchaRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_messages_common_pb.Phone;
      reader.readMessage(value,proto_messages_common_pb.Phone.deserializeBinaryFromReader);
      msg.setPhone(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceid(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIslogin(value);
      break;
    case 4:
      var value = /** @type {!proto.proto.messages.Channel} */ (reader.readEnum());
      msg.setChannel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.services.CreateCaptchaRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.services.CreateCaptchaRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.services.CreateCaptchaRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.services.CreateCaptchaRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPhone();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_messages_common_pb.Phone.serializeBinaryToWriter
    );
  }
  f = message.getDeviceid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIslogin();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getChannel();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional proto.messages.Phone phone = 1;
 * @return {?proto.proto.messages.Phone}
 */
proto.proto.services.CreateCaptchaRequest.prototype.getPhone = function() {
  return /** @type{?proto.proto.messages.Phone} */ (
    jspb.Message.getWrapperField(this, proto_messages_common_pb.Phone, 1));
};


/**
 * @param {?proto.proto.messages.Phone|undefined} value
 * @return {!proto.proto.services.CreateCaptchaRequest} returns this
*/
proto.proto.services.CreateCaptchaRequest.prototype.setPhone = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.services.CreateCaptchaRequest} returns this
 */
proto.proto.services.CreateCaptchaRequest.prototype.clearPhone = function() {
  return this.setPhone(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.services.CreateCaptchaRequest.prototype.hasPhone = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string deviceId = 2;
 * @return {string}
 */
proto.proto.services.CreateCaptchaRequest.prototype.getDeviceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.services.CreateCaptchaRequest} returns this
 */
proto.proto.services.CreateCaptchaRequest.prototype.setDeviceid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool isLogin = 3;
 * @return {boolean}
 */
proto.proto.services.CreateCaptchaRequest.prototype.getIslogin = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.services.CreateCaptchaRequest} returns this
 */
proto.proto.services.CreateCaptchaRequest.prototype.setIslogin = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional proto.messages.Channel channel = 4;
 * @return {!proto.proto.messages.Channel}
 */
proto.proto.services.CreateCaptchaRequest.prototype.getChannel = function() {
  return /** @type {!proto.proto.messages.Channel} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.proto.messages.Channel} value
 * @return {!proto.proto.services.CreateCaptchaRequest} returns this
 */
proto.proto.services.CreateCaptchaRequest.prototype.setChannel = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


goog.object.extend(exports, proto.proto.services);
